// extracted by mini-css-extract-plugin
export default {"section":"WelcomeBanner_section__q-T3r","title":"WelcomeBanner_title__MTGY+","appEntry":"WelcomeBanner_appEntry__zUkQR","appGrid":"WelcomeBanner_appGrid__Dp8WT"};